import React, { useEffect, useState, useRef } from "react";
import { Select, Input, Row, Radio, Col, Checkbox } from 'antd';
import filterIcon from '../../assets/images/icons/filter.svg';
import { SearchOutlined } from '@ant-design/icons';
import Dropdown from 'react-bootstrap/Dropdown';
import addIcon from '../../assets/images/addbtnicon/plusicon.svg';
import removeIcon from '../../assets/images/icons/minus_circle_remove_ icon.svg';

const { Option } = Select;

const MediaPlannerFilter = () => {

  const [searchValue, setSearchValue] = useState('');
  const [filterApply, setFilterApply] = useState({
    publisher: [],
  });

  const options = [
    { value: 'jack1', label: 'Jack 1' },
    { value: 'lucy1', label: 'Lucy 1' },
    { value: 'lucy8', label: 'Lucy 8' },
    { value: 'tom8', label: 'Tom 8' },
    { value: 'jack9', label: 'Jack 9' },
    { value: 'lucy9', label: 'Lucy 9' },
    { value: 'tom9', label: 'Tom 9' },
  ];

  const handleSearch = (e) => {
    setSearchValue(e.target.value.toLowerCase());
  };

  const onChange = (value) => {
    console.log(`Selected: ${value}`);
  };

  const handleFilterApply = (type, value) => {
    setFilterApply((prev) => {
      const currentPublishers = prev.publisher;
      const isSelected = currentPublishers.includes(value);

      // Toggle selection
      const updatedPublishers = isSelected
        ? currentPublishers.filter((item) => item !== value)
        : [...currentPublishers, value];

      return { ...prev, publisher: updatedPublishers };
    });
  };

  // Filtering options based on search input
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchValue)
  );

  // --------------------------------------------------------------------------------------------------------------------------------//

  const [feedListRepeaterOptions, setFeedListRepeaterOptions] = useState([])
  const [feedListRepeater, setFeedListRepeater] = useState([

  ]);

  const handleChangeRemoteId = (e, index) => {
    const listTrigger = [...feedListRepeater];
    if (/^[\d\W]*$/.test(e.target.value.trim())) {

      listTrigger[index]["remote_id"] = e.target.value.trim();
      if (e.target.value.trim().length === 0) {
        listTrigger[index]["validation_remote_id"] = true;
      }
      else {
        listTrigger[index]["validation_remote_id"] = false;
      }
      setFeedListRepeater(listTrigger);
    }

  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };


  const handleRemoveFeedListRepeater = (index) => {
    let listTrigger = [...feedListRepeater];
    listTrigger.splice(index, 1);
    setFeedListRepeater(listTrigger);
  };

  const handleAddFeedListRepeater = () => {
    setFeedListRepeater([
      ...feedListRepeater,
      {
        feed_provider_id: "",
        remote_id: "",
        validation_feed_provider_id: false,
        validation_remote_id: false
      },
    ]);
  };




  const validateFeedListRepeater = () => {
    setFeedListRepeater(prevFeedListRepeater =>
      prevFeedListRepeater.map(item => {
        const isFeedProviderIdEmpty = item.feed_provider_id === "";
        const isRemoteIdEmpty = item.remote_id === "";

        return {
          ...item,
          validation_feed_provider_id: isFeedProviderIdEmpty, // Set to true if feed_provider_id is empty
          validation_remote_id: isRemoteIdEmpty // Set to true if remote_id is empty
        };
      })
    );

    // Return true if all fields are filled, false if any are empty
    return feedListRepeater.every(item => item.feed_provider_id !== "" && item.remote_id !== "");
  };

  // const scrollableDivRef = useRef(null);

  // // Scroll to the bottom when a new form is added
  // useEffect(() => {
  //   if (scrollableDivRef.current) {
  //     scrollableDivRef.current.scrollTop = scrollableDivRef.current.scrollHeight;
  //   }
  // }, [feedListRepeater]);


  const scrollableDivRef = useRef(null);
  const [prevRepeaterCount, setPrevRepeaterCount] = useState(feedListRepeater.length);
  const [openSelectIndex, setOpenSelectIndex] = useState(null); // Track which Select is open

  // Handle scroll to close Select dropdown
  useEffect(() => {
    const handleScroll = () => {
      if (openSelectIndex !== null) {
        setOpenSelectIndex(null); // Close any open dropdown
      }
    };

    const currentDiv = scrollableDivRef.current;
    if (currentDiv) {
      currentDiv.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (currentDiv) {
        currentDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, [openSelectIndex]);

  // Scroll to the bottom when a new form is added
  useEffect(() => {
    if (feedListRepeater.length > prevRepeaterCount) {
      if (scrollableDivRef.current) {
        scrollableDivRef.current.scrollTop = scrollableDivRef.current.scrollHeight;
      }
      setPrevRepeaterCount(feedListRepeater.length);
    }
  }, [feedListRepeater]);


  return (
    <div className="container_box--wrapper pt_header">
      <div className="container_box--wrapper--title d_flex justify-content-between">
        <h1 className="heading fw_600">Domains</h1>
      </div>

      <div className="d_flex justify_content_between mb_10">
        {/* Search Input */}
        <div className="form_content_block--group">
          <Input
            type='text'
            className='form_control basic md search_input w_table_search'
            placeholder="Search"
          />
        </div>

        <div className="custom_filter_design_d2 custom_media_filter_d2">
          <Dropdown className="" autoClose={false}>
            <div className="position-relative hover_effec_hide_show_d2">
              <Dropdown.Toggle id="dropdown-autoclose-false px-2">
                <img src={filterIcon} alt="" /> Filter
              </Dropdown.Toggle>
            </div>

            <Dropdown.Menu>
              <div className="filter_inner_heading_d2">
                <div className="filter_scrollable_div_d2" ref={scrollableDivRef}>
                  {feedListRepeater.map((x, i) => {
                    return (
                      <Row gutter={8} className="formHtml align-items-center" key={i}>
                        <Col className="text-center or_and_select_d2">
                          <span className="is_text">Where</span>
                          <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                            <Select
                              showSearch={false}
                              placeholder=""
                              popupClassName="or_and_d2"
                              optionFilterProp="label"
                              className="form_select basic"
                              options={[
                                { value: 'or', label: 'or' },
                                { value: 'and', label: 'and' },
                              ]}
                              open={openSelectIndex === `select-where-${i}`}
                              onDropdownVisibleChange={(open) => setOpenSelectIndex(open ? `select-where-${i}` : null)}
                            />
                          </div>
                        </Col>
                        <Col span={6}>
                          <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                            <Select
                              showSearch={false}
                              placeholder=""
                              optionFilterProp="label"
                              className="form_select basic"
                              options={[
                                { value: 'ADCODE', label: 'ADCODE' },
                                { value: 'Country', label: 'Country' },
                                { value: 'Property 3', label: 'Property 3' },
                              ]}
                              open={openSelectIndex === `select-property-${i}`}
                              onDropdownVisibleChange={(open) => setOpenSelectIndex(open ? `select-property-${i}` : null)}
                            />
                          </div>
                        </Col>
                        <Col className="text-center px-1">
                          <span className="is_text">is</span>
                        </Col>
                        <Col span={15} className="checkbox_value_select_d2 multi_select_tag_d2">
                          <div className="form_content_block--group mb_0">
                            <div className="d-flex">
                              <div className="w-100">
                                <Select
                                  id="adcodeSelect"
                                  value={filterApply.publisher}
                                  showSearch={false}
                                  placeholder="- Select -"
                                  popupClassName="diff_select_d2"
                                  className="form_select basic"
                                  mode="multiple"
                                  maxTagCount="responsive"
                                  dropdownRender={(menu) => (
                                    <>
                                      <div className="custom_inside_searchbar_d2">
                                        <Input
                                          placeholder="Search"
                                          value={searchValue}
                                          onChange={handleSearch}
                                          prefix={<SearchOutlined className="search_icon_d2" />}
                                          allowClear
                                        />
                                      </div>
                                      {menu}
                                    </>
                                  )}
                                  open={openSelectIndex === `select-values-${i}`}
                                  onDropdownVisibleChange={(open) => setOpenSelectIndex(open ? `select-values-${i}` : null)}
                                >
                                  {filteredOptions.map((option) => (
                                    <Select.Option key={option.value} value={option.value}>
                                      <div
                                        onClick={() => handleFilterApply('publisher', option.value)}
                                        style={{ display: 'flex', alignItems: 'center' }}
                                      >
                                        <Checkbox
                                          checked={filterApply.publisher.includes(option.value)}
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          {option.label}
                                        </Checkbox>
                                      </div>
                                    </Select.Option>
                                  ))}
                                </Select>


                                {/* this html for yes or no design */}
                                <div className="form_content_block--group">
                                  <Radio.Group className="form_radio equal_space">
                                    <Radio className="radio_btn" value={true}>
                                      Yes
                                    </Radio>
                                    <Radio className="radio_btn" value={false}>
                                      No
                                    </Radio>
                                  </Radio.Group>
                                </div>
                                
                              </div>

                              <div className="download_icon_d2 d-flex align-items-center justify-content-between">
                                <img
                                  className="delete_form_icon"
                                  src={removeIcon}
                                  alt="Delete"
                                  onClick={() => handleRemoveFeedListRepeater(i)}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                </div>
                <Row>
                  <Col span={24}>
                    <div className='addnewform_d2 addnewform_filter_d2'>
                      <Dropdown className="inner_dropdown_btn_d2">
                        <Dropdown.Toggle className="dropdown-autoclose-false px-2" id="dropdown-basic">
                          <img src={addIcon} className="m-0" alt='Add Property' /> Add Property
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item href="#" onClick={handleAddFeedListRepeater}>Adcode</Dropdown.Item>
                          <Dropdown.Item href="#" onClick={handleAddFeedListRepeater}>Country</Dropdown.Item>
                          <Dropdown.Item href="#" onClick={handleAddFeedListRepeater}>Property 3</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
                <hr />
              </div>

              <div className="filter_bottom_btns_d2 text-end">
                <button className="reset" type='button'>Reset</button>
                <button className="apply" type='button'>Apply</button>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default MediaPlannerFilter;
